





































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs-uuif/shared/sw-icon';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwEmailInput extends SwExtendedVue {
  /* two way binding for main v-model */
  @Prop(String)
  value: string;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  internalValue: string | number | boolean = this.value;
  placeholdervalue: string = `${this.$t('products.enter').toString()} ${this.$t('login.phldUsername').toString()}`; // tslint:disable-line
  @Watch('value')
  onValueChange(val: string) {
    this.internalValue = val;
  }
  @Watch('internalValue')
  onInternalValueChange() {
    this.$emit('input', this.internalValue);
  }

  internalDisabled:boolean = this.disabled;
  @Watch('disabled')
  onDisabledChange(val: boolean) {
    this.internalDisabled = val;
  }

  @Watch('internalDisabled')
  onInternalDisabledChange() {
    this.$emit('input2', this.internalDisabled);
  }
  mounted() {
    setTimeout(() => {
      const inputEl = this.$refs.inputUserName as HTMLElement;
      console.warn(inputEl);
      if (inputEl) { inputEl.focus(); }
    },         3000);
  }

  focused: boolean = false;
}
